(function () {
  if (window.__sizeGuideInit) return;
  window.__sizeGuideInit = true;

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-size-guide-open]')) {
      var modal = document.querySelector('[data-size-guide-modal]');
      if (modal) modal.hidden = false;
      return;
    }
    if (event.target.closest('[data-size-guide-close]')) {
      var modal2 = event.target.closest('.size-guide-modal');
      if (modal2) modal2.hidden = true;
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var openModal = document.querySelector('.size-guide-modal:not([hidden])');
    if (openModal) openModal.hidden = true;
  });
})();
